( function () {
  // AGGRESSIVE CLEANUP: Clear any invalid discount codes immediately
  const existingDiscount = sessionStorage.getItem( "shopify_discount" )
  if ( existingDiscount && existingDiscount.toUpperCase() !== 'GET25OFF' ) {
    sessionStorage.removeItem( "shopify_discount" )
  }

  function getQueryParam ( param ) {
    const urlParams = new URLSearchParams( window.location.search )
    return urlParams.get( param )
  }

  // Function to check if LABOR25 discount is still valid
  function isLABOR25Valid () {
    // Set expiration date: September 2, 2025 at 11:59 PM PDT
    // const expirationDate = new Date( '2025-09-02T23:59:00-07:00' )
    // const currentDate = new Date()

    // // // Return true if current date is before expiration date
    // return currentDate < expirationDate
    return false
  }

  // Get discount code from query parameter or use existing one from sessionStorage
  const queryDiscount = getQueryParam( "discount" )
  let discountCode = queryDiscount

  // If no discount in URL, check sessionStorage for an existing discount code
  if ( !discountCode ) {
    const storedDiscount = sessionStorage.getItem( "shopify_discount" )
    if ( storedDiscount ) {
      discountCode = storedDiscount
    }
    // Only use the default if nothing in sessionStorage and default is valid
    else if ( isLABOR25Valid() ) {
      discountCode = "LABOR25"
    }
  }

  // SIMPLE CHECK: Only allow GET25OFF, exit early if any other code
  if ( !discountCode || discountCode.toUpperCase() !== 'GET25OFF' ) {
    // Clear any invalid discount codes from sessionStorage
    if ( discountCode && discountCode.toUpperCase() !== 'GET25OFF' ) {
      sessionStorage.removeItem( "shopify_discount" )
    }
    return // Exit the entire script - no discount logic runs
  }

  // Store the discount code in sessionStorage if it exists
  if ( discountCode ) {
    sessionStorage.setItem( "shopify_discount", discountCode )
  }

  // Helper functions for price handling
  function extractPrice ( element, getOriginalPrice = false ) {
    if ( !element ) return null

    // If we need original price (for target products)
    if ( getOriginalPrice ) {
      // Strategy 1: Look for existing del tag (compare_at_price - original price)
      const existingOriginalPrice = element.querySelector( 'del' )
      if ( existingOriginalPrice ) {
        const priceText = existingOriginalPrice.textContent.trim()
        const priceMatch = priceText.match( /\$([0-9,]+(?:\.\d{2})?)/ )
        if ( priceMatch && priceMatch[ 1 ] ) {
          const price = parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
          return price
        }
      }

      // Strategy 2: Look for data attribute storing original price
      if ( element.dataset.originalPrice ) {
        const originalPrice = parseFloat( element.dataset.originalPrice )
        if ( !isNaN( originalPrice ) ) {
          return originalPrice
        }
      }

      // Strategy 3: If no del tag, get price from ins tag (current Shopify price)
      // This handles the case where we're applying discount for the first time
      const insElement = element.querySelector( 'ins' )
      if ( insElement ) {
        const priceText = insElement.textContent.trim()
        const priceMatch = priceText.match( /\$([0-9,]+(?:\.\d{2})?)/ )
        if ( priceMatch && priceMatch[ 1 ] ) {
          const price = parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
          // Store this as the original price for future reference
          if ( !element.dataset.originalPrice ) {
            element.dataset.originalPrice = price.toString()
          }
          return price
        }
      }

      // Strategy 4: Look for price-money structure
      const priceMoneyElement = element.querySelector( 'price-money bdi' )
      if ( priceMoneyElement ) {
        const priceText = priceMoneyElement.textContent.trim()
        const priceMatch = priceText.match( /\$?([0-9,]+(?:\.\d{2})?)/ )
        if ( priceMatch && priceMatch[ 1 ] ) {
          const price = parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
          // Store this as the original price for future reference
          if ( !element.dataset.originalPrice ) {
            element.dataset.originalPrice = price.toString()
          }
          return price
        }
      }

      // Strategy 5: Fallback to main text content
      const mainPriceText = element.textContent.trim()
      const mainPriceMatch = mainPriceText.match( /\$([0-9,]+(?:\.\d{2})?)/ )
      if ( mainPriceMatch && mainPriceMatch[ 1 ] ) {
        const price = parseFloat( mainPriceMatch[ 1 ].replace( /,/g, '' ) )
        // Store this as the original price for future reference
        if ( !element.dataset.originalPrice ) {
          element.dataset.originalPrice = price.toString()
        }
        return price
      }
    } else {
      // For discounted price, get from ins tag (current price in Shopify)
      const existingDiscountedPrice = element.querySelector( 'ins' )
      if ( existingDiscountedPrice ) {
        const discountedPriceText = existingDiscountedPrice.textContent.trim()
        const discountedPriceMatch = discountedPriceText.match( /\$([0-9,]+(?:\.\d{2})?)/ )
        if ( discountedPriceMatch && discountedPriceMatch[ 1 ] ) {
          return parseFloat( discountedPriceMatch[ 1 ].replace( /,/g, '' ) )
        }
      }

      // Look for price-money structure
      const priceMoneyElement = element.querySelector( 'price-money bdi' )
      if ( priceMoneyElement ) {
        const priceText = priceMoneyElement.textContent.trim()
        const priceMatch = priceText.match( /\$?([0-9,]+(?:\.\d{2})?)/ )
        if ( priceMatch && priceMatch[ 1 ] ) {
          return parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
        }
      }

      // Fallback to main text content
      const priceText = element.textContent.trim()
      const priceMatch = priceText.match( /\$([0-9,]+(?:\.\d{2})?)/ )
      if ( priceMatch && priceMatch[ 1 ] ) {
        return parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
      }
    }

    return null
  }

  function calculateDiscountedPrice ( originalPrice, discountPercentage ) {
    return Math.round( ( originalPrice * ( 1 - discountPercentage / 100 ) ) * 100 ) / 100
  }

  function formatCurrency ( amount ) {
    return new Intl.NumberFormat( 'en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    } ).format( amount )
  }

  function formatAmountForCartPage ( amount ) {
    const dollars = Math.floor( amount )
    const cents = Math.round( ( amount - dollars ) * 100 ).toString().padStart( 2, '0' )
    return `<span class="amount"><span class="price__prefix">$</span>${ dollars }<sup class="price__suffix">.${ cents }</sup></span>`
  }

  function createPriceHTML ( originalPrice, discountedPrice, isCartPage = false ) {
    const formattedOriginal = formatCurrency( originalPrice )
    const formattedDiscounted = formatCurrency( discountedPrice )

    if ( isCartPage ) {
      const originalFormatted = formatAmountForCartPage( originalPrice )
      const discountedFormatted = formatAmountForCartPage( discountedPrice )
      return `<del>${ originalFormatted }</del> <ins>${ discountedFormatted }</ins>`
    } else {
      return `<del><span class="amount">${ formattedOriginal }</span></del> <ins><span class="amount">${ formattedDiscounted }</span></ins>`
    }
  }

  function processCartElement ( element, discountPercentage ) {
    if ( !element ) return 0

    // Check if this has a price-money element (new Shopify structure)
    const priceMoneyElement = element.querySelector( 'price-money bdi' )

    if ( priceMoneyElement ) {
      // NEW SHOPIFY STRUCTURE: Just update the price-money content
      const priceText = priceMoneyElement.textContent.trim()
      const priceMatch = priceText.match( /\$?([0-9,]+(?:\.\d{2})?)/ )

      if ( priceMatch ) {
        const originalPrice = parseFloat( priceMatch[ 1 ].replace( /,/g, '' ) )
        const discountedPrice = calculateDiscountedPrice( originalPrice, discountPercentage )

        // Just replace the entire content - simple!
        priceMoneyElement.innerHTML = createPriceHTML( originalPrice, discountedPrice )
      }

    } else {
      // OLD STRUCTURE: Use existing logic
      const originalPrice = extractPrice( element )
      if ( !originalPrice ) return 0

      const discountedPrice = calculateDiscountedPrice( originalPrice, discountPercentage )
      element.innerHTML = createPriceHTML( originalPrice, discountedPrice )
    }

    return 0
  }

  function updateDiscountElement ( discountElement, price, discountPercentage ) {
    if ( !discountElement ) return

    // Get the SVG element first to preserve it
    const svgElement = discountElement.querySelector( 'svg' )

    // Clear the element's content
    discountElement.innerHTML = ''

    // If there was an SVG, add it back
    if ( svgElement ) {
      discountElement.appendChild( svgElement )
    }

    let savingsText = ""

    if ( price ) {
      // For target products, we want to get the original price from del tag
      const originalPrice = extractPrice( price )

      if ( originalPrice ) {
        // Calculate savings amount
        const savingsAmount = originalPrice * ( discountPercentage / 100 )
        const formattedSavings = formatCurrency( savingsAmount )

        savingsText = ` (-${ formattedSavings })`
      }
    } else if ( isLABOR25Valid ) {
      savingsText = ` (-25%)`
    }

    // Get the discount code from sessionStorage
    const storedDiscount = sessionStorage.getItem( "shopify_discount" )
    // Use the stored discount code
    let discountCode = storedDiscount || `GET25OFF`

    // Special handling for LABOR25 - if we're applying 25% discount and LABOR25 is valid, use LABOR25
    if ( discountPercentage === 25 && isLABOR25Valid() ) {
      discountCode = "LABOR25"
      // Make sure sessionStorage is updated to LABOR25 for checkout
      sessionStorage.setItem( "shopify_discount", "LABOR25" )
    }

    // Create a wrapper for better styling
    const discountWrapper = document.createElement( 'span' )

    // Add the discount code
    const discountText = document.createTextNode( discountCode + savingsText )
    discountWrapper.appendChild( discountText )
    discountElement.appendChild( discountWrapper )

    // Style the savings amount if needed
    if ( savingsText ) {
      discountWrapper.style.display = 'inline-flex'
      discountWrapper.style.alignItems = 'center'
      discountWrapper.style.gap = '4px'
    }
  }

  function processCartItem ( item, discountPercentage, isCartPage = false ) {
    if ( !item ) return 0

    // Check if this is a cart recommendation
    const isCartRecommendation = item.closest( '.cart-recommendations' )

    // For target products, apply discount
    // Only add discount list for actual cart items, not cart recommendations
    if ( !isCartRecommendation ) {
      // First check if the discounts list already exists
      let discountsList = item.querySelector( '.discounts' )
      let cartDiscountElement

      if ( discountsList ) {
        // If the list exists, check for the discount element
        cartDiscountElement = discountsList.querySelector( '.discounts__discount' )
      } else {
        // Create the discounts list if it doesn't exist
        discountsList = document.createElement( 'ul' )
        discountsList.className = 'discounts'
        discountsList.setAttribute( 'role', 'list' )

        // Find the .quantity.cart-update element to insert before
        const quantityElement = item.querySelector( '.quantity.cart-update' )
        if ( quantityElement ) {
          quantityElement.parentNode.insertBefore( discountsList, quantityElement )
        } else {
          // If no quantity element, append to the item itself
          if ( isCartPage ) {
            item.querySelector( '.cart-item__details' ).appendChild( discountsList )
          } else {
            item.appendChild( discountsList )
          }
        }
      }

      // If the discount element doesn't exist, create it
      if ( !cartDiscountElement ) {
        cartDiscountElement = document.createElement( 'li' )
        cartDiscountElement.className = 'discounts__discount'

        // Add the SVG icon
        const svgIcon = document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' )
        svgIcon.setAttribute( 'xmlns', 'http://www.w3.org/2000/svg' )
        svgIcon.setAttribute( 'aria-hidden', 'true' )
        svgIcon.setAttribute( 'focusable', 'false' )
        svgIcon.setAttribute( 'class', 'icon icon-discount' )
        svgIcon.setAttribute( 'fill', 'none' )
        svgIcon.setAttribute( 'viewBox', '0 0 24 24' )

        const path = document.createElementNS( 'http://www.w3.org/2000/svg', 'path' )
        path.setAttribute( 'fill-rule', 'evenodd' )
        path.setAttribute( 'clip-rule', 'evenodd' )
        path.setAttribute( 'd', 'M10.9 2.1l9.899 1.415 1.414 9.9-9.192 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414L10.9 2.1zm2.828 8.486a2 2 0 1 0 2.828-2.829 2 2 0 0 0-2.828 2.829z' )
        path.setAttribute( 'fill', 'currentColor' )

        svgIcon.appendChild( path )
        cartDiscountElement.appendChild( svgIcon )

        // Add the discount element to the list
        discountsList.appendChild( cartDiscountElement )
      }

      // Update discount label only for actual cart items
      let cartItemPrice = item.querySelector( '.product-price .price' )
      let cartItemTotalPrice = item.querySelector( '.cart-item__totals .price' )
      updateDiscountElement( cartDiscountElement, cartItemPrice, discountPercentage )
      updateDiscountElement( cartDiscountElement, cartItemTotalPrice, discountPercentage )
    }

    // Always update price with discount (for both cart items and recommendations)
    let cartItemPrice = item.querySelector( '.product-price .price' ) || item.querySelector( '.cart-item__price-wrapper .price' )
    let cartItemTotalPrice = item.querySelector( '.cart-item__totals .price' )
    if ( cartItemPrice || cartItemTotalPrice ) {
      // For target products, we want to get the original price (from del tag if exists)
      const originalPrice = extractPrice( cartItemPrice, true )
      const originalTotalPrice = extractPrice( cartItemTotalPrice, true )

      // If we successfully extracted a price, apply our discount
      if ( originalPrice || originalTotalPrice ) {
        // Calculate our custom discount price
        const discountedPrice = calculateDiscountedPrice( originalPrice, discountPercentage )
        const discountedTotalPrice = calculateDiscountedPrice( originalTotalPrice, discountPercentage )

        // Replace the entire price element content, overriding any existing discount
        if ( isCartPage ) {
          if ( cartItemPrice ) cartItemPrice.innerHTML = createPriceHTML( originalPrice, discountedPrice, true )
          if ( cartItemTotalPrice ) cartItemTotalPrice.innerHTML = createPriceHTML( originalTotalPrice, discountedTotalPrice, true )
        } else {
          if ( cartItemPrice ) cartItemPrice.innerHTML = createPriceHTML( originalPrice, discountedPrice )
          if ( cartItemTotalPrice ) cartItemTotalPrice.innerHTML = createPriceHTML( originalTotalPrice, discountedTotalPrice )
        }

        return discountedPrice + discountedTotalPrice
      }
    }

    return 0
  }

  function updateCheckoutButton ( buttonSelector, totalPrice ) {
    const checkoutButton = document.querySelector( buttonSelector )
    if ( checkoutButton ) {
      const formattedTotal = formatCurrency( totalPrice )

      checkoutButton.textContent = formattedTotal
    }
  }

  // Add this global flag at the top of your IIFE
  let isProcessingUpdate = false

  // Add this function to update checkout totals:
  function updateCheckoutTotals ( discountPercentage ) {
    // Cart Section Total
    const cartSectionItems = document.querySelectorAll( '.cart-items .cart-item' )
    let cartSectionTotal = 0

    cartSectionItems.forEach( ( item, index ) => {
      const cartTotalPrice = item.querySelector( '.cart-item__totals .price' )

      if ( cartTotalPrice ) {
        const originalTotalPrice = extractPrice( cartTotalPrice, true )
        if ( originalTotalPrice ) {
          cartSectionTotal += calculateDiscountedPrice( originalTotalPrice, discountPercentage )
        }
      }
    } )

    // Update cart section checkout button
    updateCheckoutButton( '.totals__subtotal-value', cartSectionTotal )

    // Cart Drawer Total (same logic)
    const cartDrawerItems = document.querySelectorAll( '#mini-cart .product-container' )
    let cartDrawerTotal = 0

    cartDrawerItems.forEach( ( item, index ) => {
      // Skip cart recommendations - they shouldn't count toward total
      if ( item.closest( '.cart-recommendations' ) ) {
        return
      }

      const cartItemPrice = item.querySelector( '.price' )
      const quantityElement = item.querySelector( '[name="updates[]"], .quantity__input, input[type="number"]' )

      if ( cartItemPrice ) {
        // For target products, get original price and apply discount
        const originalPrice = extractPrice( cartItemPrice, true )

        if ( originalPrice ) {
          const discountedPrice = calculateDiscountedPrice( originalPrice, discountPercentage )

          // Get quantity (default to 1 if not found)
          let quantity = 1
          if ( quantityElement ) {
            quantity = parseInt( quantityElement.value ) || 1
          }

          cartDrawerTotal += discountedPrice * quantity
        }
      }
    } )

    // Update cart drawer checkout button
    updateCheckoutButton( '#mini-cart-subtotal', cartDrawerTotal )
  }

  // Create a reusable function to process price elements based on product ID
  function processProductPrices ( discountPercentage ) {
    // Collect all product elements that might need processing
    const productElements = [
      // Product info container
      ...document.querySelectorAll( '.hero-price' ),
      // Care routine product
      ...document.querySelectorAll( '.crrtn-sec' ),
      // Testimonial product
      ...document.querySelectorAll( '.feat-pr-awards' )
    ]

    // Process each product element
    productElements.forEach( element => {
      if ( !element ) return

      // Only process target products
      // Find the price element within this product element
      const priceElements = element.querySelectorAll( '.original-price' )

      if ( priceElements?.length > 0 ) {
        priceElements.forEach( priceElement => {
          // Apply discount to the price
          processCartElement( priceElement, discountPercentage )
        } )
      }
    } )
  }

  // Main discount application logic
  function handleDiscount ( discountPercentage ) {
    // If already processing an update, don't run again
    if ( isProcessingUpdate ) return

    // Set flag to prevent concurrent processing
    isProcessingUpdate = true

    try {
      // Process all cart items to update displays
      const cartSectionItems = document.querySelectorAll( '#mini-cart .product-container' )
      // alert( cartSectionItems )
      cartSectionItems.forEach( ( item, index ) => {
        try {
          processCartItem( item, discountPercentage, false )
        } catch ( error ) {
          console.error( `Error processing item ${ index + 1 }:`, error )
        }
      } )

      const cartDrawerItems = document.querySelectorAll( '.cart-items .cart-item' )
      cartDrawerItems.forEach( ( item ) => {
        processCartItem( item, discountPercentage, true )
      } )

      // Update checkout totals (this is now a separate function)
      updateCheckoutTotals( discountPercentage )
    } finally {
      // Always reset the flag when done
      isProcessingUpdate = false
    }
  }

  function setupCartObservers ( discountPercentage ) {
    // Listen for cart quantity changes (when items are updated/removed)
    document.addEventListener( 'cart:updated', function ( event ) {
      handleDiscount( discountPercentage )
      applyCheckoutHandlers() // Re-apply checkout handlers after cart update
    } )

    // Listen for products being added to cart
    document.addEventListener( 'ajaxProduct:added', function ( event ) {
      // Longer delay to ensure mini cart content is updated
      setTimeout( () => {
        handleDiscount( discountPercentage )
        applyCheckoutHandlers() // Re-apply checkout handlers after product added
      }, 1050 )
    } )

    // Listen for fetch-override cart events (the real cart events this theme uses)
    document.addEventListener( 'fetch-override:/cart/add', function ( event ) {
      setTimeout( () => {
        handleDiscount( discountPercentage )
        applyCheckoutHandlers()
      }, 1050 )
    } )

    document.addEventListener( 'fetch-override:/cart/update', function ( event ) {
      setTimeout( () => {
        handleDiscount( discountPercentage )
        applyCheckoutHandlers()
      }, 1050 )
    } )

    // Listen for cart drawer opening/loading
    document.addEventListener( 'cartdrawer:opened', function ( event ) {
      setTimeout( () => {
        handleDiscount( discountPercentage )
        applyCheckoutHandlers()
      }, 1050 )
    } )

    // Observe cart count changes as a fallback
    const cartCountElements = document.querySelectorAll( '.cart-count, .cart__count, [data-cart-count], .header__icon--cart .count' )
    cartCountElements.forEach( element => {
      if ( element ) {
        const observer = new MutationObserver( function ( mutations ) {
          mutations.forEach( function ( mutation ) {
            if ( mutation.type === 'childList' || mutation.type === 'characterData' ) {
              setTimeout( () => {
                handleDiscount( discountPercentage )
              }, 500 )
            }
          } )
        } )

        observer.observe( element, {
          childList: true,
          subtree: true,
          characterData: true
        } )
      }
    } )

    // Initial application
    handleDiscount( discountPercentage )
  }

  function applyCheckoutHandlers () {
    const storedDiscount = sessionStorage.getItem( "shopify_discount" )

    if ( storedDiscount && ( storedDiscount !== "LABOR25" || isLABOR25Valid() ) ) {
      // Apply discount code to checkout URLs
      const checkoutLinks = document.querySelectorAll( "a[href*='/checkout']" )
      checkoutLinks.forEach( ( link ) => {
        const checkoutURL = new URL( link.href )
        checkoutURL.searchParams.set( "discount", storedDiscount )
        link.href = checkoutURL.toString()
      } )

      // Modify checkout form submissions
      const checkoutForms = document.querySelectorAll( "form[action='/cart'], form[action*='cart'], .mini-cart" )

      checkoutForms.forEach( ( form ) => {
        // Remove existing listeners to avoid duplicates
        const existingHandler = form._checkoutHandler
        if ( existingHandler ) {
          form.removeEventListener( "submit", existingHandler )
        }

        // Create new handler
        const newHandler = function ( event ) {
          // Only intercept if it's a checkout submission (has checkout button)
          const checkoutButton = event.submitter || form.querySelector( 'button[name="checkout"]' )

          if ( checkoutButton && checkoutButton.name === "checkout" ) {
            event.preventDefault()

            let checkoutURL = new URL( window.location.origin + "/checkout" )
            checkoutURL.searchParams.set( "discount", storedDiscount )

            window.location.href = checkoutURL.toString()
          }
        }

        // Store reference and add listener
        form._checkoutHandler = newHandler
        form.addEventListener( "submit", newHandler )
      } )
    }
  }

  function applyDiscountToCheckout () {
    const storedDiscount = sessionStorage.getItem( "shopify_discount" )

    // Only apply LABOR25 discount if it's valid
    if ( storedDiscount && ( storedDiscount !== "LABOR25" || isLABOR25Valid() ) ) {
      // Apply initial checkout handlers
      applyCheckoutHandlers()

      // Set discount percentage based on the code
      let discountPercentage = 25 // Default to 25%

      // Handle GET25OFF (25% discount)
      if ( storedDiscount === "GET25OFF" ) {
        discountPercentage = 25
      }
      // Handle LABOR25 specifically
      else if ( storedDiscount === "LABOR25" ) {
        discountPercentage = 25
      }

      // Only proceed if we have a valid percentage
      if ( !isNaN( discountPercentage ) && discountPercentage > 0 && discountPercentage <= 100 ) {
        // Apply one-time discount updates
        processProductPrices( discountPercentage )

        // Setup cart observers for dynamic updates
        setupCartObservers( discountPercentage )

        // Also handle checkout buttons directly
        document.addEventListener( 'click', function ( event ) {
          if ( event.target.closest( '.checkout-button' ) ) {
            setTimeout( () => {
              updateCheckoutTotals( discountPercentage )
            }, 50 )
          }
        } )
      }
    }
  }

  // Intercept fetch requests to cart endpoints
  const originalFetch = window.fetch
  window.fetch = function ( ...args ) {
    const url = args[ 0 ]

    // Check if this is a cart request
    if ( typeof url === 'string' && ( url.includes( '/cart/add' ) || url.includes( '/cart/update' ) ) ) {
      // Call the original fetch
      const fetchPromise = originalFetch.apply( this, args )

      // After the fetch completes, apply our discounts
      fetchPromise.then( () => {
        const storedDiscount = sessionStorage.getItem( "shopify_discount" )
        if ( storedDiscount ) {
          let discountPercentage = 25 // Default to 25%

          // Handle GET25OFF (25% discount)
          if ( storedDiscount === "GET25OFF" ) {
            discountPercentage = 25
          }
          // Handle LABOR25 specifically
          else if ( storedDiscount === "LABOR25" ) {
            discountPercentage = 25
          }

          setTimeout( () => {
            if ( typeof handleDiscount === 'function' ) {
              handleDiscount( discountPercentage )
            }
          }, 1000 )
        }
      } ).catch( err => {
        console.log( 'Cart fetch error:', err )
      } )

      return fetchPromise
    }

    // For non-cart requests, just use original fetch
    return originalFetch.apply( this, args )
  }

  document.addEventListener( "DOMContentLoaded", applyDiscountToCheckout )
} )()
